import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { Subscription } from 'rxjs';
import { ModalService } from './modal.service';

@Component({
  selector: 'rav-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() revealSize?: string;
  @Input() modalTitle?: string;
  @Input() modalId: string;
  @Input() isTransparent = false;

  isVisible = false;
  private modalOpenSubscription: Subscription = new Subscription();
  private modalCloseSubscription: Subscription = new Subscription();

  constructor(private renderer: Renderer2, public modal: ModalService) {}

  ngOnInit() {
    this.modalOpenSubscription = this.modal.open.subscribe((data) => {
      if (this.modalId !== data.modalId) return;
      this.isVisible = true;
      this.renderer.addClass(document.body, 'modal-open');
    });

    this.modalCloseSubscription = this.modal.close.subscribe((data) => {
      if (data && data.modalId && this.modalId !== data.modalId) return;
      if (this.isVisible) this.isVisible = false;
      this.renderer.removeClass(document.body, 'modal-open');
    });
  }

  ngOnDestroy() {
    this.modalOpenSubscription.unsubscribe();
    this.modalCloseSubscription.unsubscribe();
  }

  /**
   * Closes the modal when the background is clicked
   *
   * @param event The click event
   */
  closeOnBgClick(event: any): void {
    if (event.target.classList.contains('reveal-overlay')) {
      this.modal.close.next({ modalId: this.modalId, canceled: true });
    }
  }
}
